export default __webpack_public_path__ + "static/TSD_Header_4_Featured-451e835a79c8c2f91c1b9652116aef8c.jpg";